<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>ثبت فرم</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol col="12">
              <CInput v-model="title"
                      label="عنوان فرم"
/>
              </CCol>
              <CCol col="12">
                <div id="surveyCreator" style="height: 100vh;"></div>


              </CCol>

            </CRow>

          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              ثبت فرم
            </CButton>
            <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              ویرایش فرم
            </CButton>
          </CCardFooter>
        </CCard>

      </CCol>
    </CRow>



  </div>

</template>

<script>
import editorjs from "@/views/includes/editorjs.vue";
import axios from "@/api/http";
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000)
}


export default {
  name: 'Login',
  components: {
    Treeselect,
    // ckeditor: CKEditor.component
  },
  data() {

    return {
      loaded_page:false,
      editor: null,
      content_json: '',
      content_text: '',
      content_html: '',
      value_category: [],
      value_tags: [],
      value_keywords: [],
      // define options
      image_upload: '',
      options_category: [],
      // editor: ClassicEditor,
      editorData: '',
      title: '',
      favorite_url: '',
      seo_title: '',
      keyword: '',
      summary: '',
      seo_summary: '',
      tags: '',
      file: null,

      previewImage: null,
      image: '',

      details: [],
      status_form: 0,

    }
  },
  mounted() {
    this.render_survey_creator()

    if (this.$route.params.post_id != null) {
      this.status_form = this.$route.params.post_id;
      this.get_post_info();
    }else{
      this.loaded_page=true
    }

  },
  watch: {
    '$route.params.post_id': function () {
      this.get_post_info();
    },
    // 'editorData': function () {
    //   let tmp = document.createElement("DIV");
    //   tmp.innerHTML = this.editorData;
    //   this.content_text = tmp.textContent || tmp.innerText || "";
    //
    //   this.content_html = this.editorData;
    // },

  },
  methods: {
render_survey_creator(){
  const creatorOptions = {
    autoSaveEnabled: true,
    collapseOnDrag: true
  };

  this.creator = new SurveyCreator.SurveyCreator(creatorOptions);
  this.creator.locale = "fa";

  this.creator.render(document.getElementById("surveyCreator"));
  this.creator.saveSurveyFunc = (saveNo, callback) => {
    // If you use localStorage:
    // window.localStorage.setItem("survey-json", creator.text);
    // console.log("survey",this.creator.text)
    callback(saveNo, true);

  };

},
    get_post_info() {
      var self = this;
      axios.get('/api/admin/site/form/'+self.status_form, {}).then(function (response) {
        var post_data = response.data;

        self.title = post_data.title;
        self.creator.text = (post_data.data);

        self.loaded_page=true

        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },


    login() {
      let self = this;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/admin/site/form";
      } else {
        url = "/api/admin/site/form";
        formData.append('id', this.status_form)
      }
      formData.append('data', this.creator.text)
      formData.append('title', this.title)

//9485
      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.title = '';
self.$router.push({path:'/dashboard/forms/list'})
        }

      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}

</script>
